module.exports = __webpack_public_path__ + "img/banner.72f2361d.jpg";